// @vendors
const get = require('lodash/object/get');
const trim = require('lodash/string/trim');

// @actions
const errorActions = require('actions/brokerError');

// @utilities
const {
    isClientTypePhysical,
    isClientTypeLegal
} = require('utilities/leiValidationMessage');

// @constants
const LEI_VALIDATION_ERROR = 'LEI404';

const leiPhysicalClientError = (history) => (dispatch) => {
    const physicalClientLeiError = 'brokerAPIErrors-stocksPhysicalClientLeiValidationError';
    dispatch(errorActions.show(physicalClientLeiError, true, history));
};

const leiLegalClientError = (history) => (dispatch) => {
    const legalClientLeiError = 'brokerAPIErrors-stocksLegalClientLeiValidationError';
    dispatch(errorActions.show(legalClientLeiError, true, history));
};

const leiValidationError = (history) => (dispatch) => {
    if (isClientTypePhysical()) {
        dispatch(leiPhysicalClientError(history));
    } else if (isClientTypeLegal()) {
        dispatch(leiLegalClientError(history));
    } else {
        dispatch(errorActions.show('', true, history));
    }
};

const brokerStocksOperationFailure = (error, history) => (dispatch) => {
    const errorCode = get(error, 'body.error', '') || get(error, 'error', '');
    const isLeiValidationError = trim(errorCode).toUpperCase() === LEI_VALIDATION_ERROR;

    if (isLeiValidationError) {
        dispatch(leiValidationError(history));
    } else {
        dispatch(errorActions.show(`brokerAPIErrors-${errorCode}`, true, history));
    }
};

module.exports = {
    brokerStocksOperationFailure
};
